import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import TimelineHomePage from './pages/TimelineHomePage';
import DarkHomePage from './pages/DarkHomePage';
import MinimalistHomePage from './pages/MinimalistHomePage';
import HeroFocusedHomePage from './pages/HeroFocusedHomePage';
import TwoColumnHomePage from './pages/TwoColumnHomePage';
import './App.css';
import { trackVisitor } from './utils/analytics';

function App() {
  useEffect(() => {
    // Track visitor data
    trackVisitor();
  }, []);

  return (
    <Router>
      <div className="app">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/home-timeline" element={<TimelineHomePage />} />
          <Route path="/home-dark" element={<DarkHomePage />} />
          <Route path="/home-minimalist" element={<MinimalistHomePage />} />
          <Route path="/home-hero-focused" element={<HeroFocusedHomePage />} />
          <Route path="/home-two-column" element={<TwoColumnHomePage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
